<template>
  <div class="content my-data-hub">
    <div class="mdh-wrap">
      <div class="mdh-head">
        <h1>My Data</h1>
        <p>Everything you've created and saved — pick where to go.</p>
      </div>

      <div class="mdh-grid">
        <router-link
          v-for="tile in visibleTiles"
          :key="tile.name"
          :to="{ name: tile.name }"
          class="mdh-card"
        >
          <span class="mdh-ico"><i class="md-icon">{{ tile.icon }}</i></span>
          <div class="mdh-title">{{ tile.title }}</div>
          <div class="mdh-desc">{{ tile.desc }}</div>
          <div class="mdh-cta">
            {{ tile.cta }}<i class="md-icon mdh-arrow">arrow_forward</i>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// "My Data" landing hub (7.17 feedback #5, redesigned 7.19 to the Bizminer design system
// — the old <profile-card> version rendered flat/unstyled). Tiles mirror the sidebar
// "My Data" section; academics see Profiles only. Design lives in the Claude Design project
// at patterns/my-data-landing.
import { mapState } from 'vuex';

export default {
  name: 'my-data-hub',
  data() {
    return {
      tiles: [
        { name: 'MyProspectList', icon: 'format_list_bulleted', title: 'Prospect Lists', cta: 'View Prospect Lists', hideForAcademic: true,
          desc: 'Targeted company lists you’ve built and saved.' },
        { name: 'MyProfiles', icon: 'folder_open', title: 'Profiles', cta: 'View Profiles', hideForAcademic: false,
          desc: 'Industry Financial, Market, and Company profiles you’ve accessed.' },
        { name: 'MyReports', icon: 'description', title: 'Reports', cta: 'View Reports', hideForAcademic: true,
          desc: 'Financial, Market, Valuation, and Company reports you’ve created.' },
        { name: 'MyData', icon: 'dns', title: 'Saved Inputs', cta: 'View Saved Inputs', hideForAcademic: true,
          desc: 'Your saved input sets that reports benchmark against.' },
      ],
    };
  },
  computed: {
    ...mapState({ isAcademic: (state) => state?.user?.user_type?.academic ?? null }),
    visibleTiles() {
      return this.tiles.filter((t) => !(this.isAcademic && t.hideForAcademic));
    },
  },
};
</script>

<style lang="scss" scoped>
/* Bizminer design-system tokens inlined — beta-selector.css :root isn't loaded on this route. */
$navy: #003666;
$navy-soft: #e8eef4;
$surface: #ffffff;
$border-2: #d3d8df;
$border: #e2e5ea;
$text: #1b1e21;
$muted: #5d6570;

.my-data-hub {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
}
.mdh-wrap { max-width: 1180px; padding: 30px 26px 60px; }
.mdh-head h1 { margin: 0; font-size: 26px; font-weight: 700; color: $navy; letter-spacing: -0.01em; }
.mdh-head p { margin: 7px 0 0; font-size: 14.5px; color: $muted; }

.mdh-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-top: 26px;
}
@media (max-width: 1100px) { .mdh-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) { .mdh-grid { grid-template-columns: 1fr; } }

.mdh-card {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  background: $surface;
  border: 1px solid $border-2;
  border-radius: 13px;
  padding: 22px 20px 18px;
  box-shadow: 0 1px 2px rgba(15, 25, 40, 0.04);
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
  min-height: 196px;
  color: $text;

  &:hover {
    transform: translateY(-3px);
    border-color: $navy;
    box-shadow: 0 12px 30px rgba(0, 54, 102, 0.14);
  }
}

.mdh-ico {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: $navy-soft;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.16s ease;

  .md-icon {
    color: $navy !important;
    font-size: 24px !important;
    transition: color 0.16s ease;
  }
}
.mdh-card:hover .mdh-ico { background: $navy; }
.mdh-card:hover .mdh-ico .md-icon { color: #fff !important; }

.mdh-title { margin: 16px 0 0; font-size: 16.5px; font-weight: 700; color: $navy; letter-spacing: -0.005em; }
.mdh-desc { margin: 6px 0 0; font-size: 13.5px; line-height: 1.55; color: $muted; flex: 1; }

.mdh-cta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid $border;
  font-size: 13px;
  font-weight: 600;
  color: $navy;
}
.mdh-arrow {
  font-size: 16px !important;
  color: $navy !important;
  transition: transform 0.16s ease;
}
.mdh-card:hover .mdh-arrow { transform: translateX(3px); }
</style>
